import React from "react";
import Testimonials from "../../components/services/sections/Testimonials";
import CarouselSlider from "../../components/carousel/CarouselSlider";
import TrustedBy from "../../components/services/sections/TrustedBy";
import Pricing from "../../components/services/sections/Pricing";
import HowItWorks from "../../components/services/sections/HowItWorks";
import ServiceSlider from "../../components/services/common/ServiceSlider";
import WhatWhySections from "../../components/services/sections/WhatWhySections";
import {
  academicData,
  trustedByData,
  serviceSliderText,
} from "../../components/services/data";

const Academic = () => {
  return (
    <>
      <CarouselSlider />
      <WhatWhySections {...academicData} />
      <TrustedBy {...trustedByData} />
      <HowItWorks />
      <Pricing />
      <Testimonials name="academic" />
      <ServiceSlider
        header={serviceSliderText.academic.header}
        subHeader={serviceSliderText.academic.subHeader}
      />
    </>
  );
};

export default Academic;
